import Vue from 'vue'
import App from './App.vue'
import i18n from '@/locales/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@fortawesome/fontawesome-free/css/all.css'
import router from './router'
import axios from 'axios'
import { getClientTag } from '@/utils/index'
import { getCountryByDomain, DOMAIN_CONFIG, getApiBaseUrl } from '@/common/config'

// axios请求拦截器，自动加 areatype
axios.interceptors.request.use(
  config => {
    const country = getCountryByDomain(window.location.hostname)
    config.headers['Accept-Language'] = i18n.locale.replace('_', '-')
    config.headers['areatype'] = getClientTag(country)
    config.baseURL = getApiBaseUrl(country)
    return config
  },
  error => Promise.reject(error)
)

const country = getCountryByDomain(window.location.hostname)
console.log(`[Init] 当前国家: ${country}, 当前域名: ${DOMAIN_CONFIG[country]}`)

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
